import Typography from "antd/lib/typography";
import clsx from "clsx";
import { HtmlRichTextRenderer } from "src/components/inputs/RichText";

import { IAnnouncementResource } from "@sol/sdk";
import { Card } from "@sol/uikit/data-display/Card/Card";

import styles from "./AnnouncementCard.module.css";
import { getAnnouncementVideoEmbedUrl } from "../lib/getAnnouncementVideoEmbedUrl";

export const formatAnnouncementDate = (appearanceDate: string) => {
    const normalizedDate = appearanceDate.includes("T") ? appearanceDate : `${appearanceDate}T12:00:00`;

    return new Intl.DateTimeFormat(undefined, { dateStyle: "long" }).format(new Date(normalizedDate));
};

type Props = {
    announcement: IAnnouncementResource;
    className?: string;
};

export const AnnouncementCard = ({ announcement, className }: Props) => {
    const embedUrl = getAnnouncementVideoEmbedUrl(announcement.videoUrl);

    return (
        <Card className={clsx(className)} data-cy="announcement-card">
            <div className="flex flex-col gap-ant-sm">
                <Typography.Text type="secondary">
                    {formatAnnouncementDate(announcement.appearanceDate)}
                </Typography.Text>
                <Typography.Title level={3} className="mt-0!">
                    {announcement.title}
                </Typography.Title>
                <article>
                    <HtmlRichTextRenderer className={styles.content} html={announcement.body} />
                </article>
                {embedUrl && (
                    <div className="rounded-ant-md mt-ant-sm aspect-video w-11/12 max-w-3xl self-start overflow-hidden">
                        <iframe
                            src={embedUrl}
                            className="size-full border-0"
                            allowFullScreen
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            title="Video"
                        />
                    </div>
                )}
            </div>
        </Card>
    );
};

export default AnnouncementCard;
